import React from 'react'
import BaseIcon from './BaseIcon'

/*eslint-disable */
export default class Message extends BaseIcon {
  static defaultProps = {
    width: 37,
    height: 31,
    viewBox: '0 0 37 31'
  }
  render () {
    return (
      <svg {...this.getSvgProps()}>
        <g>
          <path d='M36.2 12.58l-5.8-2.43V2.58C30.4 1.16 29.2 0 27.74 0H9.24C7.8 0 6.6 1.16 6.6 2.58v7.57L.8 12.58c-.48.2-.8.67-.8 1.2V28.4C0 29.84 1.18 31 2.64 31h31.72c1.46 0 2.64-1.16 2.64-2.58V13.77c0-.52-.32-1-.8-1.2zm-.64 1.14l-5.17 2.9v-5.07l5.14 2.17zM7.93 2.58c0-.7.6-1.3 1.32-1.3h18.5c.73 0 1.32.6 1.32 1.3v14.77l-10.57 5.9-10.57-5.9V2.58zM6.6 11.55v5.06l-5.16-2.86 5.17-2.17zm29.1 16.87c0 .7-.6 1.3-1.32 1.3H2.64c-.73 0-1.32-.6-1.32-1.3V15.14l16.52 9.23c.2.1.43.17.66.17.23 0 .45-.06.66-.17l16.52-9.23v13.28z'
            {...this.getPathProps()} />
          <path d='M25.77 5.17h-6.6c-.37 0-.67-.3-.67-.65 0-.36.3-.65.66-.65h6.6c.37 0 .67.3.67.65 0 .36-.3.65-.66.65zm0 3.87H11.23c-.36 0-.66-.3-.66-.64 0-.36.3-.65.66-.65h14.54c.36 0 .66.3.66.65 0 .35-.3.64-.66.64zm0 3.88H11.23c-.36 0-.66-.3-.66-.65 0-.36.3-.64.66-.64h14.54c.36 0 .66.28.66.64s-.3.65-.66.65zm0 3.88H11.23c-.36 0-.66-.3-.66-.65 0-.36.3-.65.66-.65h14.54c.36 0 .66.3.66.65 0 .35-.3.64-.66.64z'
            {...this.getPathProps()} />
        </g>
      </svg>
    )
  }
}
/*eslint-enable */
